import React from "react";
import {catalogItemModel} from "./libraryFactory";
import {LibraryCatalogItem} from "./LibraryCatalogItem";
import {ResultsPager} from "../../Components/Grid";

interface LibraryCatalogViewProps {
    resources: Record<string, any>[];
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string, format?: string) => void;
    handleOrderRequest: (catalogId: string, catalogFormatId: string) => void;
    handleSetLibrarySearchCriteria: (criteria: Record<string, any>) => void;
    librarySearchCriteria: Record<string, any>;
    totalRecords: number;
}

export const LibraryCatalogView = ({
                                       resources,
                                       handleAddToQueue,
                                       handleEdit,
                                       handleOrderRequest,
                                       handleSetLibrarySearchCriteria,
                                       librarySearchCriteria,
                                       totalRecords
                                   }: LibraryCatalogViewProps) => {

    const handleFirstClick = () => {
        let criteria = {...librarySearchCriteria};
        criteria.First();

        handleSetLibrarySearchCriteria(criteria);
    };

    const handlePreviousClick = () => {
        let criteria = {...librarySearchCriteria};
        criteria.Previous();

        handleSetLibrarySearchCriteria(criteria);
    };

    const handleNextClick = () => {
        let criteria = {...librarySearchCriteria};
        criteria.Next();

        handleSetLibrarySearchCriteria(criteria);
    };

    const handleLastClick = () => {
        let criteria = {...librarySearchCriteria};
        criteria.Last(totalRecords);

        handleSetLibrarySearchCriteria(criteria);
    };


    const pager = (isSecondaryPager: boolean) =>
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={librarySearchCriteria.recordsPerPage}
            currentPage={librarySearchCriteria.page}
            disabled={false}
        />;

    return (
        <>
            {pager(false)}
            {resources.map((resource: Record<string, any>) => {
                const item = catalogItemModel(resource);
                return (
                    <LibraryCatalogItem
                        key={item.catalogId}
                        handleAddToQueue={handleAddToQueue}
                        handleEdit={handleEdit}
                        handleOrderRequest={handleOrderRequest}
                        {...item}
                    />
                );
            })}
            {pager(true)}
        </>
    );
};

